// src/Register.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  auth,
  createUserWithEmailAndPassword,
} from "../../../features/firebase";
import { useCookies } from "react-cookie";
import Loading from "../../components/Loading/Loading";
import "./RegistAccpage.scss";
import { motion } from "framer-motion";

const RegistAccpage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  // eslint-disable-next-line
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [loading, setLoading] = useState(false);

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      if (!user.emailVerified) {
        setCookie("user", JSON.stringify(user), { path: "/", maxAge: 604800 });
        navigate("/verifikasi");
      } else if (user) {
        setCookie("user", JSON.stringify(user), { path: "/", maxAge: 604800 });
        navigate("/registrasi-profil");
      }
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        setError("Akun Sudah Teregistrasi");
      }
    } finally {
      setLoading(false);
    }
  };

  // const handleDeleteAccount = async () => {
  //   try {
  //     setLoading(true);
  //     const user = auth.currentUser;
  //     if (user) {
  //       await deleteUser(user);
  //       removeCookie("user");
  //       navigate("/"); // Arahkan ke halaman utama setelah menghapus akun
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     if (error.code === "auth/requires-recent-login") {
  //       navigate(`/checkpoint/hapus-akun?uid=${cookies.user.uid}`);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="registration-account-page"
    >
      {loading && <Loading />}
      <div className="registration-account-box">
        <h1>Registrasi akun</h1>
        <form onSubmit={handleRegister}>
          <div className="registration-input">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="email"
            />
            <i className="fa-brands fa-google"></i>
          </div>

          <div className="registration-input">
            <input
              type="password"
              value={password}
              placeholder="password"
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <i className="fa-solid fa-key"></i>
          </div>
          {error && (
            <p
              style={{
                color: "yellow",
                margin: "10px 0px",
                textAlign: "center",
              }}
            >
              {error}
            </p>
          )}
          <button type="submit">Register</button>
        </form>
      </div>
    </motion.main>
  );
};

export default RegistAccpage;
